// src/pages/Subtitling.js
import React from 'react';
import { NavLink } from 'react-router-dom';

const Subtitling = () => (
  <>
    {/* Breadcrumb */}
    <div
      className="optech-breadcrumb"
      style={{ backgroundImage: 'url(/assets/images/breadcrumb/breadcrumb.png)' }}
    >
      <div className="container">
        <h1 className="post__title">Subtitling</h1>
        <nav className="breadcrumbs">
          <ul>
            <li>
              <NavLink to="/services">AI Service</NavLink>
            </li>
            <li aria-current="page">Subtitling</li>
          </ul>
        </nav>
        <p className="text-white pt-5">
          Subtitles enable viewers to understand audiovisual content across language barriers or when sound is not available. R A Inc handles multilingual subtitling, ensuring the retention of nuance, context, and emotional significance within each frame.
        </p>
      </div>
    </div>

    {/* Service Section */}
    <div className="section optech-section-padding">
      <div className="container">
        <div className="row">
          {/* Left Content Area */}
          <div className="col-lg-8">
            <div className="optech-service-details-wrap">
              <img
                data-aos="fade-up"
                data-aos-duration="800"
                src="/assets/images/service/subtitling.jpg"
                alt="Subtitling Service"
                className="mb-4 w-100"
              />

              {/* Overview Section */}
              <div className="optech-service-details-item">
                <h3>Overview</h3>
                <p>
                  Effective subtitling involves more than just translating text. Timely on-screen placement is key, balancing readability with the pace of the visuals. Linguistic expertise must be coupled with a firm grasp of technical subtitling standards and the capacity to condense dialogue without distorting its meaning. Our method ensures an engaging viewer experience, whether it’s a cinematic film, an instructional video, or a promotional clip.
                </p>
              </div>

              {/* Types of Subtitling */}
              <div className="optech-service-details-item">
                <h3>Types of Subtitling</h3>
                <div className="optech-icon-list">
                  <ul>
                    <li>
                      <i className="ri-check-line" />
                      <strong>Intralingual:</strong> Subtitles in the same language as the source, aiding the hearing impaired or language learners.
                    </li>
                    <li>
                      <i className="ri-check-line" />
                      <strong>Interlingual:</strong> Translations from one language to another, broadening the material’s global reach.
                    </li>
                    <li>
                      <i className="ri-check-line" />
                      <strong>Foreign Footage:</strong> Transforming international content into a locally comprehensible version, including cultural references.
                    </li>
                  </ul>
                </div>
              </div>

              {/* Subtitling Workflow Table */}
              <div className="optech-service-details-item">
                <h3>Subtitling Workflow</h3>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Step</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Script Analysis</td>
                      <td>Examine text for tone, specialized terms, or cultural notes</td>
                    </tr>
                    <tr>
                      <td>Translation</td>
                      <td>Convey the essence of spoken lines, while adjusting for reading speed</td>
                    </tr>
                    <tr>
                      <td>Timing & Sync</td>
                      <td>Align subtitle entries accurately with video or on-screen cues</td>
                    </tr>
                    <tr>
                      <td>Review</td>
                      <td>Confirm that timing, language, and style harmonize effectively</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Highlights */}
              <div className="optech-service-details-item">
                <h3>Highlights</h3>
                <ul className="list-unstyled">
                  <li><i className="ri-check-line" />Maintains the emotional color of dialogues, capturing jokes or dramatic moments.</li>
                  <li><i className="ri-check-line" />Adheres to industry norms regarding subtitle length and display time.</li>
                  <li><i className="ri-check-line" />Supports multiple file formats for compatibility with different playback systems.</li>
                </ul>
              </div>

              {/* Conclusion */}
              <div className="optech-service-details-item">
                <h3>Conclusion</h3>
                <p>
                  Subtitling can significantly broaden the reach of any video-based content, transforming region-specific media into something accessible worldwide. R A Inc’s skilled approach ensures every subtitle line is properly timed, carefully translated, and contextually faithful, establishing a better connection with your target audience.
                </p>
              </div>
            </div>
          </div>

          {/* Sidebar Section */}
          <div className="col-lg-4">
            <div className="optech-service-sidebar">
              <div className="optech-service-menu">
                <ul>
                  {[
                    { name: 'Multimedia & DTP Services',       slug: '/multimedia-and-dtp-services' },
                    { name: 'Audio & Video Transcription',     slug: '/audio-and-video-transcription' },
                    { name: 'Desktop Publishing Services',     slug: '/desktop-publishing-services' },
                    { name: 'Subtitle Services',               slug: '/subtitling' },
                    { name: 'Multilingual Desktop Publishing', slug: '/multilingual-desktop-publishing' },
                    { name: 'Multimedia & DTP Tools',          slug: '/multimedia-and-dtp-tools' }
                  ].map(service => (
                    <li key={service.slug}>
                      <NavLink to={service.slug}>
                        {service.name} <i className="ri-arrow-right-up-line" />
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>

              <div
                className="optech-service-contact"
                data-aos="fade-up"
                data-aos-duration="800"
                style={{ backgroundImage: 'url(/assets/images/service/bg.png)' }}
              >
                <div className="optech-service-contact-icon">
                  <img src="/assets/images/service/icon.svg" alt="" />
                </div>
                <h3>Need Subtitling Support?</h3>
                <p>Work with our subtitling experts to ensure your content is accessible, accurate, and engaging for any audience.</p>
                <NavLink className="optech-default-btn" data-text="Get in Touch" to="/contact-us">
                  <span className="btn-wraper">Get in Touch</span>
                </NavLink>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    {/* Call To Action */}
    <div
      className="section bg-cover optech-section-padding"
      style={{ backgroundImage: 'url(/assets/images/cta/cta-bg2.png)' }}
    >
      <div className="container">
        <div className="optech-cta-wrap">
          <div className="optech-cta-content center">
            <h2>Let's Translate Your Vision Into Every Language</h2>
            <p>
              Whether you're expanding your business internationally or need multilingual content for local markets, we provide solutions tailored to your goals, audience, and tone.
            </p>
            <div className="optech-extra-mt" data-aos="fade-up" data-aos-duration="800">
              <NavLink className="optech-default-btn" data-text="Let’s Start a Project" to="/contact-us">
                <span className="btn-wraper">Let’s Start a Project</span>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default Subtitling;